export enum CertificateStatus {
  APPROVED = 1,
  PENDING_APPROVAL = 2,
  REJECTED = 3,
  EXPIRED = 4
}
